module.exports = __webpack_public_path__ + "img/ModifDocAssuraf.772f0084.png";